/**
*** 指定したオブジェクトに合わせてバリデーションしてその結果を返す
*** @param {*} getParameters で取得したパラメータ
*** @param {*} rules object
*** @return Object
**/
export const getValidateResults = ( params, rules ) => {

  // 変数を再設定
  const name    = params.name,
        value   = params.value,
        element = vivaFormElements[name];

  let temporary = [];

  // rules loop
  for( const rule in rules ){

    temporary.push({
      rule: rule,
      valid: Parameters.method[rule]( value, element, params ),
      message: rules[rule]
    });

    // 必須（ required ）のときはグローバルパラメータにフラグを立てる
    if( rule === 'required' ) {
      Parameters.params[name].required = true;
    };
  };

  // バリデーションが false のものを検索して最初にヒットしたものを取得
  const isFalse = temporary.find(object => object.valid === false );

  // 結果をセットするオブジェクト
  const results = {
    name    : name,
    message : isFalse ? isFalse.message : null,
    valid   : isFalse ? isFalse.valid : true
  };

  return results;

}
